<template>
  <div class="container my-10 lg:my-20">
    <Heading
      v-if="data.title"
      :semantic="isSemantic"
      :level="level"
      class="mb-5 text-2xl font-bold lg:text-3xl"
      >{{ data.title }}</Heading
    >
    <div v-if="data.html" class="mb-10" v-html="data.html"></div>
    <ContactForm v-if="!isFormSubmitted" @submitted="isFormSubmitted = true" />
    <div v-else>
      <div class="text-2xl">{{ $t('form.thankYou') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.title)

const isFormSubmitted = ref(false)
</script>
